import api from './api';

function unwrapPayload(data) {
  if (!data || typeof data !== 'object') return data;
  if (data.data !== undefined && data.data !== null) return data.data;
  return data;
}

export const listOrganizationUsers = async () => {
  const response = await api.get('/organization/users');
  return unwrapPayload(response.data);
};

export const inviteOrganizationUser = async ({ name, email, phone, roleId }) => {
  const body = { name, email, role_id: roleId };
  if (phone) {
    body.phone = phone;
  }
  const response = await api.post('/organization/users/invite', body);
  return response.data;
};

export const setOrganizationUserSuspended = async (userId, suspended) => {
  const response = await api.patch(`/organization/users/${userId}/suspend`, {
    suspended: Boolean(suspended),
  });
  return response.data;
};

/**
 * Remove membership only (login kept).
 * DELETE /api/organization/users/{userId}
 */
export const removeOrganizationUser = async (userId) => {
  const response = await api.delete(`/organization/users/${userId}`);
  return response.data;
};

/**
 * Soft-delete the user account (status=deleted), revoke sessions + FCM tokens.
 * DELETE /api/organization/users/{userId}/account
 * Distinct from removeOrganizationUser (org membership only).
 */
export const deleteOrganizationUserAccount = async (userId) => {
  const response = await api.delete(`/organization/users/${userId}/account`);
  return response.data;
};

/** Map API errors for account delete (incl. sole_admin_required). */
export function getAccountDeleteErrorMessage(error) {
  const data = error?.response?.data || {};
  const code = data.error_code ?? data.errorCode ?? data.code;
  const message = String(data.message || '');
  if (
    code === 'sole_admin_required'
    || message.toLowerCase().includes('only organization admin')
  ) {
    return 'Assign another admin before deleting this account.';
  }
  return data.message || error?.message || 'Could not delete account.';
}

export const listOrganizationRoles = async () => {
  const response = await api.get('/organization/roles');
  return unwrapPayload(response.data);
};

export const createOrganizationRole = async ({ name, slug, description }) => {
  const body = { name };
  if (slug) body.slug = slug;
  if (description) body.description = description;
  const response = await api.post('/organization/roles', body);
  return response.data;
};

export const updateOrganizationRole = async (roleId, payload) => {
  const response = await api.put(`/organization/roles/${roleId}`, payload);
  return response.data;
};

export const deleteOrganizationRole = async (roleId) => {
  const response = await api.delete(`/organization/roles/${roleId}`);
  return response.data;
};

export const assignOrganizationUserRole = async (userId, roleId) => {
  const response = await api.post(`/organization/users/${userId}/assign-role`, {
    role_id: roleId,
  });
  return response.data;
};
